export const selectTokens = (state) => state.tokens;
export const selectAccessToken = (state) => state.tokens.accessToken;
export const selectRefreshToken = (state) => state.tokens.refreshToken;
export const selectTokenType = (state) => state.tokens.tokenType;
export const selectIsAuthenticated = (state) => state.tokens.isAuthenticated;
export const selectTokenExpiration = (state) => state.tokens.expiresAt;
export const selectRefreshTokenExpiration = (state) => state.tokens.refreshExpiresAt;
export const selectIsSessionExpiredByInactivity = (state) => state.tokens.isSessionExpiredByInactivity;
export const selectIsTokenExpired = (state) => {
    const expiresAt = state.tokens.expiresAt;
    if (!expiresAt)
        return false;
    return Date.now() >= expiresAt;
};
export const selectIsRefreshTokenExpired = (state) => {
    const expiresAt = state.tokens.refreshExpiresAt;
    if (!expiresAt)
        return false;
    return Date.now() >= expiresAt;
};
export const selectShouldRefreshToken = (state) => {
    const expiresAt = state.tokens.expiresAt;
    const refreshToken = state.tokens.refreshToken;
    const isSessionExpiredByInactivity = state.tokens.isSessionExpiredByInactivity;
    if (isSessionExpiredByInactivity)
        return false;
    if (!expiresAt || !refreshToken)
        return false;
    const thresholdTime = Date.now() + 120 * 1000;
    return expiresAt <= thresholdTime;
};
export const selectAuthorizationHeader = (state) => {
    const { accessToken, tokenType } = state.tokens;
    if (!accessToken || !tokenType)
        return null;
    return `${tokenType} ${accessToken}`;
};
